import { faHomeAlt, faSeedling } from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import TransitionLabelledButton from "./TransitionLabelledButton";

export default function OverviewButtons() {
  const location = useLocation();
  const segments = location.pathname.split("/");
  const isCropOverviewVisible = segments.length >= 3;
  const cropOverviewPath = segments[1] ? "/" + segments[1] : "/";

  return (
    <Box
      sx={{
        zIndex: 999,
        position: "absolute",
        bottom: "1rem",
        left: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <Box
        sx={{
          display: isCropOverviewVisible ? "block" : "none",
        }}
      >
        <TransitionLabelledButton
          direction="right"
          label="CROP OVERVIEW"
          icon={faSeedling}
          background="rgb(145, 215, 10)"
          color="#fff"
          to={cropOverviewPath}
        />
      </Box>
      <Box
        sx={{
          display: location.pathname === "/" ? "none" : "block",
        }}
      >
        <TransitionLabelledButton
          direction="right"
          label="FARM OVERVIEW"
          icon={faHomeAlt}
          background="rgb(0, 160, 195)"
          color="#fff"
          to="/"
          forceFade={isCropOverviewVisible}
        />
      </Box>
    </Box>
  );
}
